module.exports = __webpack_public_path__ + "static/1HOVER-f56b532e4d3bb8e96a4046190521b02d.png";